// GENERATED by scripts/build-icons.mjs from icons/user.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const User = createIcon('user', [
  ['path', { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
  ['circle', { cx: "12", cy: "7", r: "4" }],
])
